import { eventsApi } from '@entities/events/api';
import cn from 'classnames';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { EventList, EventListFilter, EventListHead } from '@widgets/events';
import { Header } from '@widgets/header';
import { Search, useFilter } from '@features/common';
import { useMobileVisibilityFilter } from '@features/events';
import { ArrowShortLeft } from '@shared/assets';
import { useAppSelector } from '@shared/hooks';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { IconButton, ListBody, PageHead } from '@shared/ui';
import { selectTab } from '@src/library/redux/events';
import * as st from './styles.module.scss';

export const EventMain: React.FC = () => {
  const nav = useNavigate();
  const { module } = useModuleByCodeParam();
  const [titles, setTitles] = useState<string[]>([]);
  const [isSearchMobile, setIsSearchMobile] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    tags,
    selectedTags,
    onTagChange,
    search,
    onSearch,
    // authors,
    selectedAuthors,
    onAuthorChange,
  } = useFilter();

  const listParams = {
    search,
    tags: selectedTags,
    authors: selectedAuthors,
    module: module?.id,
    bytime: searchParams.get('bytime'),
  };

  const tab = useAppSelector(selectTab);

  const listKey = `${tab.code}${JSON.stringify(selectedTags)}${JSON.stringify(selectedAuthors)}${search}${searchParams.get('bytime')}`;

  const [showFilterBar, setShowFilterBar] = useState(false);
  const { mobileWithFilterOn } = useMobileVisibilityFilter(showFilterBar);

  const IsActiveFilterBtn = showFilterBar || !!selectedTags.length || !!selectedAuthors.length;
  // || selectedModule;
  const isActiveFilter = !!selectedTags.length || !!selectedAuthors.length;
  // || selectedModule;

  const handleShowFilterBar = (): void => {
    setShowFilterBar((prev) => !prev);
  };

  const handleResetFilter = () => {
    // resetSelectedModule();
    onTagChange([]);
    onAuthorChange([]);
  };

  const handleClickArchiveBtn = () => {
    nav('archive');
    // if (searchParams.get('bytime')) {
    //   searchParams.delete('bytime');
    //   setSearchParams(searchParams);
    // } else {
    //   searchParams.set('bytime', 'past');
    //   setSearchParams(searchParams);
    // }
  };

  return (
    <>
      {!isSearchMobile && (
        <>
          <Header
            MCenter={<>{mobileWithFilterOn ? 'Фильтр' : 'Мероприятия'}</>}
            menuClassName={mobileWithFilterOn ? st.hide : ''}
          />

          <EventListHead
            showFilter={showFilterBar}
            filterBtnIsActive={!!IsActiveFilterBtn}
            onFilterBtnClick={handleShowFilterBar}
            onResetFilter={handleResetFilter}
            onSearch={onSearch}
            search={search}
            titles={titles}
            toggleSearch={() => setIsSearchMobile((prev) => !prev)}
            isLoading={isLoading}
            onArchive={handleClickArchiveBtn}
            isActiveArchive={!!searchParams.get('bytime')}
          />
        </>
      )}

      {isSearchMobile && (
        <>
          <Header MCenter={<>Поиск</>} isHiddenHamburger={isSearchMobile} />
          <PageHead
            Left={
              <IconButton
                variant="dark"
                onClick={() => {
                  setIsSearchMobile(!isSearchMobile);
                  onSearch('');
                }}
              >
                <ArrowShortLeft />
              </IconButton>
            }
            Right={
              <>
                <Search
                  mobile
                  search={search}
                  onSearch={onSearch}
                  titles={titles}
                  isLoading={isLoading}
                />
              </>
            }
          />
        </>
      )}

      <ListBody>
        <div className={cn(st.main, !showFilterBar && st.hideBar)}>
          <EventListFilter
            isOpen={showFilterBar}
            hasResetButton={!mobileWithFilterOn && !!isActiveFilter}
            // authors={authors}
            selectedAuthors={selectedAuthors}
            onAuthorChange={onAuthorChange}
            tags={tags}
            handleResetFilter={handleResetFilter}
            onTagChange={onTagChange}
            selectedTags={selectedTags}
          />
          <div className={cn(st.list, mobileWithFilterOn && st.hide)}>
            <EventList
              key={listKey}
              params={listParams}
              api={eventsApi}
              setTitles={setTitles}
              setLoading={setLoading}
            />
          </div>
        </div>
      </ListBody>
    </>
  );
};
